<template>
  <div id="app">
    <AppHeader />
    <router-view />
    <AppFooter />
    <CartModal
      :visible="cartModalVisible"
      @close="closeCartModal"
    />
    <LoginModal :visible="loginModalVisible" />
    <RegisterModal :visible="registerModalVisible" />
    <ForgotPasswordModal :visible="forgotPasswordModalVisible" />
    <AccountOverviewModal
      :visible="accountModalVisible"
      :initial-tab="accountModalTab"
      @close="closeAccountModal"
    />
    <BaseToast
      :visible="toast.visible"
      :message="toast.message"
      :type="toast.type"
      @close="HIDE_TOAST"
    />
    <button id="_aihecong_chat_container_body" class="floating-chat-btn" aria-label="在线客服">
      <img src="@/assets/static/index/xiaoxi.png" alt="在线客服" />
    </button>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import { BaseToast, CartModal, LoginModal, RegisterModal, ForgotPasswordModal, AccountOverviewModal } from './components/common'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    BaseToast,
    CartModal,
    LoginModal,
    RegisterModal,
    ForgotPasswordModal,
    AccountOverviewModal
  },
  computed: {
    ...mapState(['toast']),
    ...mapGetters([
      'cartModalVisible',
      'loginModalVisible',
      'registerModalVisible',
      'forgotPasswordModalVisible',
      'accountModalVisible',
      'accountModalTab'
    ])
  },
  created() {
    this.LOAD_CART()
    this.LOAD_USER()
    if (this.$store.state.user) {
      this.loadNotifications()
      this.loadCart()
    }
  },
  methods: {
    ...mapActions(['closeCartModal', 'closeAccountModal', 'loadNotifications', 'loadCart']),
    ...mapMutations(['HIDE_TOAST', 'LOAD_CART', 'LOAD_USER'])
  }
}
</script>

<style lang="scss">
@import './styles/index.scss';

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fafafa;
}

router-view {
  flex: 1;
}

.floating-chat-btn {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 1000;
  width: 65px;
  height: 65px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #2a9df4;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &:hover {
    // transform: scale(1.08);
  }

  img {
    display: block;
    width: 34px;
    height: 34px;
    object-fit: contain;
  }
}
</style>
